export default __webpack_public_path__ + "static/media/fracuccino-drink.6579150d.webp";